// ** React Imports

// ** Reactstrap Imports
import { Row } from 'reactstrap'
import { useState, Fragment, useEffect } from 'react'
import DebtEntry from './borc-girisi/DebtEntry'
import DebtDetails from './borc-girisi/DebtDetails'
import { useFormik } from 'formik'
import moment from 'moment'
import * as Yup from 'yup'
// ** Custom Components
import CustomBreadcrumb from '../../../components/customBreadcrumb/CustomBreadcrumb'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { ApartmentAreaTypes } from './store/types'
import ApproveModal from '../../../components/approveModal'
import GoBackButton from '../../../components/goBackButton/GoBackButton'

const index = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [selectedDebtor, setSelectedDebtor] = useState([])
  const [debtEntryCheck, setDebtEntryCheck] = useState(false)
  const [modal, setModal] = useState(false)
  const [approve, setApprove] = useState(false)

  useEffect(() => {
    document.title = t('Vayonet | Metrekare Bazlı Borç Girişi')
  }, [])

  const validationSchema = Yup.object({
    apartment_id: Yup.number(),
    accounting_type_id: Yup.number().min(1, t('RqMess')).required(t('RqMess')),
    accounting_type_label: Yup.string().required(t('RqMess')),
    amount: Yup.string(),
    due_date: Yup.string().required(t('RqMess')),
    last_interest: Yup.string().required(t('RqMess')),
    description: Yup.string(),
    buildings: Yup.array(),
    interest_date: Yup.string().required(t('RqMess')),
    interest_rate: Yup.number().required(t('RqMess')),
    interest_type: Yup.number().required(t('RqMess')),
    is_interest: Yup.boolean(),
    amountType: Yup.number(),
  })
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    resetForm,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: {
      apartment_id: '',
      accounting_type_id: 0,
      accounting_type_label: 'Seçiniz',
      amount: '',
      due_date: moment(new Date()).format('DD.MM.YYYY'),
      last_interest: moment(new Date()).format('DD.MM.YYYY'),
      description: '',
      buildings: [],
      amountType: 2, //1 tam 2 ondalık
      interest_date: moment(new Date()).format('DD.MM.YYYY'),
      interest_rate: 0,
      interest_type: 1,
      is_interest: false,
    },
    validationSchema,
    onSubmit: (values) => {
      setModal(true)
      if (approve) {
        setDebtEntryCheck(!debtEntryCheck)
        dispatch({
          type: ApartmentAreaTypes.ADD_AREA_DEBT,
          payload: {
            interest: {
              date: values.interest_date,
              interest_type: values.interest_type,
              rate: parseInt(values.interest_rate),
            },
            is_interest: values.is_interest,
            accounting_type_id: values.accounting_type_id,
            last_interest: values.last_interest,
            due_date: values.due_date,
            apartment_id: values.id,
            description: values.description,
            apartments: values.building_id
              ? selectedDebtor.filter(
                  (el) =>
                    el.amount > 0 &&
                    el.selected === true &&
                    values.building_id === el.building_id
                )
              : selectedDebtor.filter(
                  (el) => el.amount > 0 && el.selected === true
                ),
          },
        })
        resetForm()
        setModal(false)
        setApprove(false)
      }
    },
  })
  return (
    <Fragment>
      <div>
        <Row>
          <div className="d-flex align-items-center">
            <CustomBreadcrumb
              label={t('Metrekare Bazlı Borç Girişi')}
              firstPath="/apps/coklu-borc-giris"
              firstTitle={t('Borçlandırma')}
              secondPath="#"
              secondTitle={t('Metrekare Bazlı Borç Girişi')}
            />
            <GoBackButton goBackTo="/apps/coklu-borc-giris" />
          </div>
          <DebtDetails
            values={values}
            touched={touched}
            errors={errors}
            resetForm={resetForm}
            setFieldValue={setFieldValue}
            handleSubmit={handleSubmit}
            handleChange={handleChange}
          />
          <DebtEntry
            handleSubmit={handleSubmit}
            values={values}
            setFieldValue={setFieldValue}
            setValues={setValues}
            setSelectedDebtor={setSelectedDebtor}
            selectedDebtor={selectedDebtor}
            setDebtEntryCheck={setDebtEntryCheck}
            debtEntryCheck={debtEntryCheck}
            resetForm={resetForm}
          />
          <ApproveModal
            modal={modal}
            setModal={setModal}
            handleSubmit={(e) => {
              e.preventDefault()
              setApprove(true)
              handleSubmit()
            }}
            title={t('Yeni Borç')}
            description={t('Yeni borç eklemek istediğinizden emin misiniz?')}
            resetForm={resetForm}
          />
        </Row>
      </div>
    </Fragment>
  )
}

export default index
